import { useContext } from 'react'
import { Modal, Alert } from 'rsuite'
import { WrapperContext } from '../../../../interfaces/contexts'

var numberF = new Intl.NumberFormat('vi-VN', {
  style: 'currency',
  currency: 'VND',
})

export const TableModal = ({ className, isShow = false, style }) => {
  const { initModal, carts } = useContext(WrapperContext)

  const rowClick = (item) => {
    const list = carts.state ?? []
    const prod = list.find((m) => m.isbn == item.isbn)
    if (!prod) {
      list.push({ ...item, quantity: 1 })
    } else {
      prod.quantity += 1
    }
    carts.setState([...list])
    Alert.success('Thêm vào giỏ hàng thành công', 2000)
  }

  return (
    <Modal
      className={`m-table-modal ${className}`}
      backdrop={true}
      backdropClassName="m-table-modal__backdrop"
      show={isShow}
      style={style}
      onHide={() => initModal.setState(null)}
    >
      <div className="__table-heading">Biểu mẫu đặt hàng</div>
      <div
        style={{
          maxHeight: 'calc(100vh - 15rem)',
          maxWidth: 'calc(100vw - 80px)',
          overflowY: 'auto',
        }}
      >
        <table>
          <thead>
            <tr style={{ background: initModal.state.color }}>
              <th>Mã ISBN</th>
              <th>Cấp</th>
              <th>Lớp</th>
              <th>Loại sách</th>
              <th>Tên tựa sách</th>
              <th>Publisher</th>
              <th>Series</th>
              <th>Giá bán</th>
              <th>Chiết khấu</th>
              <th>#</th>
            </tr>
          </thead>
          <tbody>
            {initModal.state.list.map((item) => (
              <tr key={item.isbn} onClick={() => rowClick(item)}>
                <td>{item.isbn}</td>
                <td>{item.level}</td>
                <td>{item.class}</td>
                <td>{item.category}</td>
                <td>{item.title}</td>
                <td>{item.publisher}</td>
                <td>{item.seriesName}</td>
                <td>{numberF.format(item.price)}</td>
                <td align="center">{`${item.discount}%`}</td>
                <td align="center">
                  <a>
                    <img
                      width="30"
                      height="30"
                      src="./images/icons/ic-add.png"
                    />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Modal>
  )
}
